import { render, staticRenderFns } from "./ClearBlockedUsersPopup.vue?vue&type=template&id=77879c94&scoped=true&"
import script from "./ClearBlockedUsersPopup.vue?vue&type=script&lang=ts&"
export * from "./ClearBlockedUsersPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ClearBlockedUsersPopup.vue?vue&type=style&index=0&id=77879c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77879c94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77879c94')) {
      api.createRecord('77879c94', component.options)
    } else {
      api.reload('77879c94', component.options)
    }
    module.hot.accept("./ClearBlockedUsersPopup.vue?vue&type=template&id=77879c94&scoped=true&", function () {
      api.rerender('77879c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/ClearBlockedUsersPopup.vue"
export default component.exports